import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
            <img
            src="https://fbb.obs.cn-east-3.myhuaweicloud.com/png/20250714162711_HVuhvw.png"
            alt="Logo"
            className="w-8 h-8 rounded-lg object-cover"
          />
              <span className="font-bold text-xl">服帮帮</span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              服帮帮，专注于安徽南部及周边省份城市的加工厂与以杭州为主的订单企业对接服务。
            </p>
          </div>

          {/* Contact Info 靠右 */}
          <div className="md:col-start-4 md:col-end-5 md:justify-self-end">
            <h3 className="text-lg font-semibold mb-4">联系我们</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-gray-400" />
                <span className="text-gray-400">+86 133 2909 2355</span>
              </div>
              {/* <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-gray-400" />
                <span className="text-gray-400">info@huangshan.com</span>
              </div> */}
              <div className="flex items-center space-x-3">
                <MapPin className="w-6 h-6 text-gray-400 flex-shrink-0" />
                <span className="text-gray-400">安徽省黄山市祁门县祁山镇龙门坦工业园区服装产业园1栋208</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 服帮帮. 保留所有权利。
              <span className="mx-2">|</span>
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400">皖ICP备2025074557号</a>
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">隐私政策</Link>
              <Link to="/user-agreement" className="text-gray-400 hover:text-white text-sm transition-colors">用户协议</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 